// @ts-nocheck
import { ADD_MESSAGE, REMOVE_MESSAGE, SETUP_MESSAGES } from '@/components/messages/messagesActions'

export const NAME = 'messages'

const defaultState = {
  messages: [],
  logIndex: {},
}

const hashString = string => {
  let hash = 0
  if (string.length === 0) {
    return hash
  }
  for (let i = 0; i < string.length; i++) {
    const char = string.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash // Convert to 32bit integer
  }
  return hash
}

export default function placeholderReducer(state = defaultState, action) {
  let messages = []
  let logIndex = {}
  switch (action.type) {
    case ADD_MESSAGE:
      // eslint-disable-next-line no-case-declarations
      const logIdx = hashString(action.headline + action.message)
      logIndex = { ...state.logIndex }
      if (action.showOnlyOnce && logIndex[logIdx]) {
        return {
          ...state,
        }
      }
      logIndex[logIdx] = true
      return {
        ...state,
        messages: [...state.messages, { headline: action.headline, text: action.message }],
        logIndex: { ...logIndex },
      }

    case REMOVE_MESSAGE:
      messages = [...state.messages]
      if (action.idx > -1) messages.splice(action.idx, 1)
      return {
        ...state,
        messages: [...messages],
      }

    case SETUP_MESSAGES:
      messages = []
      if (action.customerMessage && action.customerMessage !== '')
        messages.push({ headline: 'Informasjon fra arbeidsgiver', text: action.customerMessage })
      if (action.tcmMessage && action.tcmMessage !== '')
        messages.push({ headline: 'Informasjon fra Skytech Control', text: action.tcmMessage })
      if (action.userMessage && action.userMessage !== '')
        messages.push({ headline: 'Informasjon til deg', text: action.userMessage })
      return {
        ...state,
        messages: messages,
      }

    default:
      return state
  }
}
